import { Array, Union } from "runtypes";
import type { Static } from "runtypes";
import { WorkflowStats } from "./WorkflowStats";
import { WorkflowFetchError } from "./WorkflowFetchError";

export const GetWorkflowsStats = Array(Union(WorkflowStats, WorkflowFetchError));

export type GetWorkflowsStats = Static<typeof GetWorkflowsStats>;
